import API from '../../libs/api';
import { store } from '../../reducers/store';
import { showAlert } from '../radminUploads';

export const LOGIN = 'login';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAILED = 'login_failed';
export const LOGIN_COMPLETED = 'LOGIN_COMPLETED';

export const LOGIN_MFA_REQUIRED = 'LOGIN_MFA_REQUIRED';
export const UPDATE_MFA_STATUS = 'UPDATE_MFA_STATUS';

export const SET_TEMP_TOKEN = 'SET_TEMP_TOKEN';




export const LOGGED_IN = 'logged_in';
export const LOGOUT = 'logout';
export const LOGGED_OUT = 'logged_out';

export const GET_USER_INFO = 'get_user_info';
export const GET_USER_INFO_SUCCESS = 'get_user_info_success';

export const RESET_AUTH_ERROR = 'RESET_AUTH_ERROR';




export const CREATE_VERIFICATION_DEVICE_REQUEST = 'CREATE_VERIFICATION_DEVICE_REQUEST';
export const CREATE_VERIFICATION_DEVICE_SUCCESS = 'CREATE_VERIFICATION_DEVICE_SUCCESS';

export const SET_IS_HAVE_UPLOADS = 'SET_IS_HAVE_UPLOADS';

export const GET_RECO_CONFIG_SUCCESS = 'GET_RECO_CONFIG_SUCCESS';

export const GET_PROVIDERS_LIST_SUCCESS = 'GET_PROVIDERS_LIST_SUCCESS';


export const login = ({ email, password, history }) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: LOGIN });

      const response = await API.postRequest('/auth/token/login/', { email, password });

      const { mfa_enabled, mfa_required, access, refresh , token} = response.data;

      if (mfa_required && !mfa_enabled) {
        dispatch({ 
          type: LOGIN_MFA_REQUIRED, 
          payload: { 
            tempToken: token,
            user: { email },
            mfaEnabled: mfa_enabled,
            mfaRequired: mfa_required
          } 
        });
        
        history.push('/multi-factor-authentication');
        return;
      }
      
      if (mfa_required && mfa_enabled) {
        dispatch({ 
          type: LOGIN_MFA_REQUIRED, 
          payload: { 
            tempToken: token, 
            mfaEnabled: mfa_enabled,
            mfaRequired: mfa_required,
            email: email
          } 
        });
        
        history.push('/multi-factor-verification');
        return;
      }

      dispatch({ 
        type: LOGIN_SUCCESS, 
        payload: { 
          accessToken: access,
          refreshToken: refresh, 
          user: { email },
          mfaEnabled: mfa_enabled,
          mfaRequired: mfa_required
        } 
      });

      const user = await dispatch(loadUserInfo());
      
      if(user.is_verified){
        dispatch({ type: LOGIN_SUCCESS, payload: { 
          accessToken: getState().auth.accessToken,
          refreshToken: getState().auth.refreshToken, user: { email: getState().auth.user.email }, isVerifiedUser: true } });
        window.analytics.track('Login Success', { email });
        
        if (user.role === 'doctor') {
          history.push('/auth/appointments');
        } else if (user.role === 'radiology_admin') {
          const isUserHaveUploads = getState().auth.user.isHaveUploads;
          const landingPage = getState().auth.user.landing_page;
          history.push(isUserHaveUploads ? (landingPage === 'dashboard' ? '/auth/radAdmin/Overview' : '/auth/radAdmin/followUpList') : '/auth/radAdmin/followUpList');
        } else {
          const planId = getState().checkout.planId;
          history.push(planId ? `/plans/${planId}/checkout` : '/auth/dashboard');
        }
      }
      
    } catch (error) {
      if (error.status === 401 && error.response?.data?.code === 'password_expired') {
        store.dispatch(showAlert('danger', 'Error', error.response?.data?.detail || 'Your password has expired, Please reset your password.'));
        history.push('/forgot-password');
      } else {
        dispatch({ type: LOGIN_FAILED, payload: { error: error.response?.data?.detail || 'Incorrect email and/or password.' } });
      }
      window.analytics.track('Login Error', { email });
    } finally {
      dispatch({ type: LOGIN_COMPLETED });
    }
  };
};


export const loadUserInfo = () => {
  return async (dispatch) => {
    try {
      const { data : user } = await API.getRequest(`/api/v1/user/me/`);
      const results = user.reco_config  
      const providerData = user.provider
      const data = user.providers

      const responseData = {
        conditional: providerData?.see_conditional_recommendation,
        negated: providerData?.see_negated_recommendation,
        provider: providerData,
        rangeStart: results?.default_days_to_maturity,
        rangeEnd: results?.default_days_to_expiry,
        unequalModRangeStart: results?.unequal_modality_default_days_to_maturity,
        unequalModRangeEnd: results?.unequal_modality_default_days_to_expiry,
        nlp_post_impression: providerData?.nlp_post_impression,
        id: results?.id,
        name: providerData?.name,
        impliedModality: results?.implied_modality_imputation,
        excludedExamCodes: results?.excluded_exam_codes,
        mammogramInEmails:  results?.mammogram_in_emails,
        attributionValue: results?.attribution_window_adherence,
        defaultRangeStart: results?.default_initial_exam_date_gte_days,
        defaultRangeEnd: results?.default_initial_exam_date_lte_days,
        showDefaultDate: results?.default_initial_exam_date_enabled,
        showStatusOverride: results?.calculate_reco_status,
        patientAgeInterval:results?.patient_age_interval,
       
      }

      
      dispatch({ type: GET_RECO_CONFIG_SUCCESS, payload: responseData });

      dispatch({ type: GET_PROVIDERS_LIST_SUCCESS, payload: data });
      
      let roles;
      if(user?.permission_level){
       roles = await API.getRequest(`/api/v1/invited-users-access/?permission_level=${user.permission_level}&page_size=${100}`);
      }
      if(user?.mfa_enabled && !user?.is_verified){
        return user
      }

      window.analytics.identify(user.id, { email: user.email, role: user.role });
    
      const isHaveUploads = true;

      const payload = {
        ...user,
        isHaveUploads,
        permissions:roles?.data?.results || []
      };

      dispatch({
        type: GET_USER_INFO_SUCCESS,
        payload: {
          user: payload
        }
      });


      return payload;
    } catch (error) {
      console.error(error);
      dispatch(logout());
    }
  };
};

export const logout = () => {
  return async (dispatch, getState) => {
    try {
      const refreshToken = getState().auth.refreshToken;

      if (refreshToken) {
        await API.postRequest('/auth/token/logout/', {
          refresh: refreshToken,
        });
      }
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      dispatch({ type: LOGOUT });
      window.analytics.reset();
    }
  };
};

export const resetAuthError = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: RESET_AUTH_ERROR
      });
    } catch (err) {}
  };
};



export const SetupVerificationDevice = ( phoneNumber ) => {
  return async (dispatch) => {
      dispatch({ type: CREATE_VERIFICATION_DEVICE_REQUEST })
      await API.postRequest(`/api/v1/verification_device/`, {
        phone_number: `+${phoneNumber}`
      })
  };
};

export const verifyMFA = (code, tempToken, isBackupMode = false) => {
  return async (dispatch, getState) => {
    try {
      const formData = new FormData();
      formData.append('code', code);
      formData.append('token', tempToken);
      if (isBackupMode) {
        formData.append('is_backup_mode', 'true');
      }

      const response = await API.postRequest(
        '/api/v1/mfa/verify/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      const { access, refresh } = response.data;
      const { email } = getState().auth;

      dispatch({ 
        type: LOGIN_SUCCESS, 
        payload: { 
          accessToken: access,
          refreshToken: refresh,
          user: { email },
          isVerifiedUser: true,
        } 
      });

      const user = await dispatch(loadUserInfo());
      dispatch({ type: LOGIN_COMPLETED });

      return { success: true, user };
      
    } catch (error) {
      dispatch({ type: LOGIN_COMPLETED });
      return {
        success: false,
        error: error?.response?.data?.error || error?.response?.data?.message || 'Verification failed'
      };
    }
  };
};

export const enableMFA = (tempToken) => {
  return async (dispatch) => {
    try {
      const response = await API.postRequest(
        '/api/v1/mfa/enable/',
        { token: tempToken }
      );
      
      return {
        success: true,
        data: {
          qr_code: response.data.qr_code,
          secret_key: response.data.secret_key
        }
      };
    } catch (error) {
      return {
        success: false,
        error: error?.response?.data?.detail || error?.response?.data?.message || 'Failed to setup MFA'
      };
    }
  };
};

export const verifyMFASetup = (code, tempToken) => {
  return async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append('code', code);
      formData.append('token', tempToken);

      const response = await API.postRequest(
        '/api/v1/mfa/mfa_verify/',
        formData,
        {
          headers: {
            'Authorization': `Token ${tempToken}`,
            'Content-Type': 'multipart/form-data',
          }
        }
      );

      return {
        success: true,
        backup_codes: response.data.backup_codes || []
      };
    } catch (error) {
      return {
        success: false,
        error: error?.response?.data?.detail || error?.response?.data?.message || 'Invalid verification code'
      };
    }
  };
};

export const resendVerificationToken = () => {
  return async (dispatch) => {
    try {
      await API.getRequest(`/api/v1/verification_device/resend_token`);
      return {
        success: true
      }
    } catch (err) {
      dispatch(showAlert('danger', 'Error', err.message));
    }
  };
};